export { ATTACHMENT_ALLOWED_EXTENSIONS, ATTACHMENT_MAX_SIZE_BYTES } from '@ooh/contracts';
export const ATTACHMENT_INPUT_ACCEPT = '.pdf,.doc,.docx,.xls';
